function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.66699 0.666666C3.11471 0.666666 2.66699 1.11438 2.66699 1.66667V14.3333C2.66699 14.8856 3.11471 15.3333 3.66699 15.3333H12.3337C12.8859 15.3333 13.3337 14.8856 13.3337 14.3333V4.66667L9.33366 0.666666H3.66699Z",
  fill: "#20A464"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.66699 15.3333C3.11471 15.3333 2.66699 14.8856 2.66699 14.3333V14.1667C2.66699 14.719 3.11471 15.1667 3.66699 15.1667H12.3337C12.8859 15.1667 13.3337 14.719 13.3337 14.1667V14.3333C13.3337 14.8856 12.8859 15.3333 12.3337 15.3333H3.66699Z",
  fill: "#149456"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.66699 0.666666C3.11471 0.666666 2.66699 1.11438 2.66699 1.66667V1.83333C2.66699 1.28105 3.11471 0.833333 3.66699 0.833333H9.50033L9.33366 0.666666H3.66699Z",
  fill: "#38AE74"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3335 8.08333V4.66667L12.7501 4.08333H9.93702C9.7143 4.08333 9.60276 4.35262 9.76025 4.51011L13.3335 8.08333Z",
  fill: "url(#paint0_linear_503_7789)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33301 0.666666L13.333 4.66667H10.333C9.78072 4.66667 9.33301 4.21895 9.33301 3.66667V0.666666Z",
  fill: "#8ED1B1"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6663 7.83333V12.6667H5.33301V7.83333H10.6663ZM7.66634 8.5H5.99967V9.33333H7.66634V8.5ZM8.33301 9.33333V8.5H9.99967V9.33333H8.33301ZM7.66634 9.83333H5.99967V10.6667H7.66634V9.83333ZM8.33301 10.6667V9.83333H9.99967V10.6667H8.33301ZM7.66634 11.1667H5.99967V12H7.66634V11.1667ZM8.33301 12V11.1667H9.99967V12H8.33301Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_503_7789",
  x1: 11.51,
  y1: 8.08333,
  x2: 11.51,
  y2: 4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#20A464"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#207E55"
})));

function SvgSheets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheets);
export default __webpack_public_path__ + "static/media/Sheets.321c40c7.svg";
export { ForwardRef as ReactComponent };